import { Button, Col, DatePicker, Form, Input, Modal, Row } from 'antd';
import '../../styles/_orgs.scss';
import { usePostOrderSetsMutation } from '../../features/organization/organizationService';
import { OrderSetRequest, OrderSetResponse } from '../../models/OrderSetModels';

type FieldType = {
    name: string;
    description: string;
};

const ValidationMessage = ({ message }: { message: string }) => {
    return <span className="ms-3">{message}</span>;
};

const OrderSetForm = ({ isUpdate = false, kitName = "", kitDesc = "", organizationName, form, openModal, handleSubmit, onCancel }: 
    { isUpdate: boolean, kitName?: string, kitDesc?: string, organizationName?: string, form: any, openModal: boolean, handleSubmit: () => void, onCancel: () => void }) => {
    return (
        <Modal
                title={isUpdate ? `Manage Comfort Kit/Order Set: ${kitName}` : `Add New Comfort Kit/Order Set to ${organizationName}`}
                centered
                className="new-team-modal my-3"
                open={openModal}
                footer={null}
                onOk={() => onCancel()}
                onCancel={() => onCancel()}
                destroyOnClose
                width={1200}
            >
                <Form
                    form={form}
                    name="basic"
                    layout="horizontal"
                    autoComplete="off"
                    className="orgs-new-team-form"
                >
                    <Row>
                        <Col span={20}>
                            <Form.Item<FieldType>
                                label={'Comfort Kit/Order Set Name'}
                                labelCol={{ span: 6 }}
                                name="name"
                                initialValue={kitName}
                                rules={[
                                    {
                                        required: true,
                                        message: (
                                            <ValidationMessage message="Please enter name" />
                                        ),
                                    },
                                ]}
                            >
                                <Input
                                    maxLength={35}
                                    showCount
                                    placeholder="Enter Comfort Kit/Order Set Name"
                                    className="ms-3 ps-0 bg-light-blue-thin rounded-1 w-100" 
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20}>
                            <Form.Item
                                label="Description"
                                name="description"
                                labelCol={{ span: 6 }}
                                initialValue={kitDesc}
                                rules={[
                                    {
                                        required: true,
                                        message: (
                                            <ValidationMessage message="Please enter description" />
                                        ),
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    showCount
                                    maxLength={1000}
                                    placeholder="Enter Description"
                                    style={{ height: 120, resize: 'none' }}
                                    className="ms-3 bg-light-blue-thin rounded-1 w-100"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={5} offset={5}>
                            <Button type="primary" className="mt-1 ms-3 bg-light-blue border-0" style={{width:'160px'}} shape="round" onClick={handleSubmit}>
                                Save
                            </Button>
                        </Col>
                    </Row>
                </Form>            
        </Modal>
        
    );
};

export default OrderSetForm;
